import { render } from "./UiList.vue?vue&type=template&id=e8d58272&ts=true"
import script from "./UiList.vue?vue&type=script&lang=ts"
export * from "./UiList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__